export default __webpack_public_path__ + "static/media/BOD Special Meeting July 20, 2020.303e8b08.pdf";